export const config = {
  connectInstanceUrl: import.meta.env.VITE_CONNECT_INSTANCE_URL as string,
  connectRegion: (import.meta.env.VITE_CONNECT_REGION as string) ?? 'us-east-1',
  apiUrl: import.meta.env.VITE_API_URL as string,
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
};
